import React from 'react';
import { Thermometer, Beef, CookingPot } from 'lucide-react';

const Kelebihan: React.FC = () => {
  const features = [
    {
      title: "HALAL",
      desc: "Diproses secara syar'i, mulai dari proses pemotongan hingga proses marinasi. Kami menjamin 100% kehalalan produk.",
      icon: (
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/1/1c/Halal_Indonesia.svg"
          className="w-12 h-12 object-contain brightness-0 invert"
          alt="Logo Sertifikasi Halal Indonesia"
        />
      ),
    },
    {
      title: "CRISPY",
      desc: "Proses pemasakan 170°C sehingga menghasilkan tekstur yang renyah dan citarasa sempurna.",
      icon: (
        <div className="flex flex-col items-center text-white">
          <Thermometer size={32} strokeWidth={2.5} />
          {/* Menaikkan ukuran font ke 12px (text-xs) agar lolos tes kontras */}
          <span className="text-xs font-black mt-[-2px]">170°C</span>
        </div>
      ),
    },
    {
      title: "SEGAR",
      desc: "Pengiriman dan uji kelayakan bahan baku terstandar, yang menjamin kualitas kesegaran dan higienis.",
      icon: <Beef size={40} strokeWidth={2.5} />,
    },
    {
      title: "JUICY",
      desc: "Dimarinasi dengan racikan 12 bumbu rahasia sehingga gurihnya meresap sampai ke bagian dalam dan tulang.",
      icon: <CookingPot size={40} strokeWidth={2.5} />,
    },
  ];

  return (
    <section 
      className="bg-[#ee1d23] py-24 text-white relative overflow-hidden"
      aria-label="Kelebihan Produk Kami"
    >
      {/* Dekorasi Background - Ditambah aria-hidden agar tidak dibaca screen reader */}
      <div
        aria-hidden="true"
        className="absolute left-0 top-0 h-full w-[20%] bg-amber-400 hidden xl:block opacity-20"
        style={{
          clipPath: "polygon(0 0, 0 100%, 100% 50%)",
          transform: "translateX(-30%)",
        }}
      ></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16 max-w-5xl mx-auto">
          {features.map((item, index) => (
            <div key={index} className="flex flex-row items-start gap-6 group">
              {/* Lingkaran Ikon - Menggunakan border putih solid untuk kontras maksimal */}
              <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-full border-2 border-white flex items-center justify-center group-hover:scale-110 group-hover:bg-white group-hover:text-[#ee1d23] transition-all duration-500">
                {item.icon}
              </div>
              
              {/* Teks */}
              <div className="flex flex-col justify-center min-h-[80px] md:min-h-[96px]">
                {/* Menggunakan h2 atau h3 secara berurutan membantu SEO/Aksesibilitas */}
                <h3 className="text-2xl md:text-4xl font-serif font-black tracking-tight mb-2 uppercase">
                  {item.title}
                </h3>
                {/* Mengganti text-white/90 menjadi text-white solid untuk skor kontras 100% */}
                <p className="text-sm md:text-base text-white font-medium leading-relaxed max-w-sm">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Kelebihan;